import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSun = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M13.125 4.375V1.75a.875.875 0 0 1 1.75 0v2.625a.875.875 0 0 1-1.75 0ZM21 14a7 7 0 1 1-7-7 7.008 7.008 0 0 1 7 7Zm-1.75 0a5.25 5.25 0 1 0-10.499 0 5.25 5.25 0 0 0 10.499 0ZM6.38 7.62a.875.875 0 1 0 1.24-1.24L5.87 4.63a.875.875 0 1 0-1.24 1.24l1.75 1.75Zm0 12.76-1.75 1.75a.876.876 0 0 0 1.24 1.24l1.75-1.75a.875.875 0 1 0-1.24-1.24ZM21 7.876a.875.875 0 0 0 .62-.256l1.75-1.75a.876.876 0 0 0-1.24-1.238l-1.75 1.75A.875.875 0 0 0 21 7.875Zm.62 12.506a.876.876 0 0 0-1.24 1.238l1.75 1.75a.875.875 0 0 0 1.24-1.238l-1.75-1.75ZM5.25 14a.875.875 0 0 0-.875-.875H1.75a.875.875 0 0 0 0 1.75h2.625A.875.875 0 0 0 5.25 14ZM14 22.75a.875.875 0 0 0-.875.875v2.625a.875.875 0 1 0 1.75 0v-2.625A.875.875 0 0 0 14 22.75Zm12.25-9.625h-2.625a.875.875 0 1 0 0 1.75h2.625a.875.875 0 1 0 0-1.75Z" />
  </svg>
);
export default SvgSun;
